export default class General {
  constructor(api) {
    this.api = api;
  }

  dashboardStats() {
    return this.api.fetchJson('/api/general/dashstats');
  }
}
